export const actions: any = [
  {
    title: 'Add New Asset',
    action: 'add-asset',
    hidden: false,
    icon: 'add-icon',
  },
];
